import es from "@/i18n/es.json";
import en from "@/i18n/en.json";

const resources = { es, en };
const LOCALE_STORAGE_KEY = "ef_lang";
const storedLocale = typeof window === "undefined" ? null : window.localStorage.getItem(LOCALE_STORAGE_KEY);
const initialPath = typeof window === "undefined" ? "" : window.location.pathname;
const publicPathLocale = /^\/en(?:\/|$)/.test(initialPath)
  ? "en"
  : (/^\/(?:blog|herramientas)(?:\/|$)/.test(initialPath) || ["/", "/precios", "/equipo-editorial", "/autora"].includes(initialPath) ? "es" : null);
let activeLocale = publicPathLocale || (storedLocale === "en" ? "en" : "es");

export function setLocale(locale) {
  const nextLocale = locale === "en" ? "en" : "es";
  if (typeof window !== "undefined") window.localStorage.setItem(LOCALE_STORAGE_KEY, nextLocale);
  if (activeLocale === nextLocale) return nextLocale;
  activeLocale = nextLocale;
  if (typeof window !== "undefined") window.dispatchEvent(new Event("i18n:localeChanged"));
  return activeLocale;
}

export const getLocale = () => activeLocale;

export const toggleLocale = () => setLocale(activeLocale === "es" ? "en" : "es");

export function subscribeLocale(listener) {
  if (typeof window === "undefined") return () => {};
  window.addEventListener("i18n:localeChanged", listener);
  return () => window.removeEventListener("i18n:localeChanged", listener);
}

export function translate(key, values = {}, locale = activeLocale) {
  const value = key.split(".").reduce((current, part) => current?.[part], resources[locale] || es)
    ?? key.split(".").reduce((current, part) => current?.[part], es)
    ?? key;
  return typeof value === "string"
    ? value.replace(/{{\s*(\w+)\s*}}/g, (_, name) => String(values[name] ?? ""))
    : key;
}

export { es, en };
